import { render } from "./NoTalkRoom.vue?vue&type=template&id=a0c43f54&ts=true"
import script from "./NoTalkRoom.vue?vue&type=script&lang=ts&setup=true"
export * from "./NoTalkRoom.vue?vue&type=script&lang=ts&setup=true"

import "./NoTalkRoom.vue?vue&type=style&index=0&id=a0c43f54&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/communityTalk/talkRoom/NoTalkRoom.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a0c43f54"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a0c43f54', __exports__)) {
    api.reload('a0c43f54', __exports__)
  }
  
  module.hot.accept("./NoTalkRoom.vue?vue&type=template&id=a0c43f54&ts=true", () => {
    api.rerender('a0c43f54', render)
  })

}


export default __exports__